import script from "./CreateOrderGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrderGuide.vue?vue&type=script&lang=ts&setup=true"

import "./CreateOrderGuide.vue?vue&type=style&index=0&id=2c218470&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c218470"]])

export default __exports__